module.exports = "<!doctype html> HTML_CONTENT";


//////////////////
// WEBPACK FOOTER
// ./resources/js/data/WordTemplate.html
// module id = oqnz
// module chunks = 70